import { Card, CardContent } from "@/components/ui/card";
import { blockSections } from "@/lib/sacred-pages/cms-helpers";

function renderSection(section) {
  const { type, content, id } = section;
  if (!content) return null;

  if (type === "image") {
    return (
      <img
        key={id}
        src={content}
        alt={section.alt || ""}
        className="w-full max-h-80 object-cover rounded-xl shadow-card"
      />
    );
  }

  if (type === "html") {
    return (
      <div
        key={id}
        className="prose prose-neutral max-w-none text-foreground/90"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  if (type === "markdown") {
    const lines = content.split("\n").map((line, i) => {
      if (line.startsWith("**") && line.endsWith("**")) {
        return (
          <p key={i} className="font-medium">
            {line.slice(2, -2)}
          </p>
        );
      }
      if (line.startsWith("### ")) {
        return (
          <h3 key={i} className="font-heading text-xl mt-4 mb-2">
            {line.slice(4)}
          </h3>
        );
      }
      return (
        <p key={i} className="text-muted-foreground leading-relaxed">
          {line}
        </p>
      );
    });
    return (
      <div key={id} className="space-y-2">
        {lines}
      </div>
    );
  }

  if (type === "json") {
    let pretty = content;
    try {
      pretty = JSON.stringify(JSON.parse(content), null, 2);
    } catch (_) {}
    return (
      <pre key={id} className="text-xs bg-muted/40 p-4 rounded-lg overflow-auto">
        {pretty}
      </pre>
    );
  }

  return (
    <p key={id} className="text-muted-foreground leading-relaxed whitespace-pre-wrap">
      {content}
    </p>
  );
}

export function UniversalPageRenderer({ page, className = "" }) {
  if (!page) return null;

  const hero = page.metadata?.hero_image;
  const sections = blockSections(page);

  return (
    <div className={`max-w-3xl mx-auto ${className}`} data-testid={`cms-page-${page.slug}`}>
      {hero && (
        <img src={hero} alt="" className="w-full max-h-64 object-cover rounded-xl mb-8 shadow-card" />
      )}
      {page.title && (
        <h1 className="font-heading text-4xl md:text-5xl font-medium mb-6 text-foreground">{page.title}</h1>
      )}
      <div className="space-y-8">
        {sections.map((sec) => (
          <Card key={sec.id} className="bg-white/80 shadow-card border-0">
            <CardContent className="pt-6">{renderSection(sec)}</CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
